<template>
  <div class="content">
    <div class="bannerWrap">
      <div class="topbanner EC_width display_between">
        <div class="bannerleft">
          <swiper :options="swiperOption"
                  v-if="topRotation && topRotation.length > 0"
                  ref="mySwiper_info">
            <swiper-slide v-for="(item, index) in topRotation"
                          :key="index">
              <!-- <img :src="item.resUrl" class="imgBanner" @click="Towindowurl(item.url)" style="cursor:pointer" width="930" height="380"> -->
              <img :src="item.resUrl"
                   class="imgBanner"
                   style="border-radius: 20px 0px 0px 0px; cursor: pointer;"
                   width="930"
                   height="380"
                   @click="Towindowurl(item.url)" />
            </swiper-slide>
            <div class="swiper-pagination"
                 slot="pagination"></div>
          </swiper>
        </div>
        <div class="bannerright">
          <swiper :options="swiperOption2"
                  ref="mySwiper">
            <swiper-slide v-for="(item, index) in topRotation"
                          :key="index"
                          @click="Towindowurl(item.url)"
                          :style="{ backgroundImage: 'url(' + item.resRightUrl + ')', backgroundSize: '100% 100%' }">
              <div>
                <img src="/image/index/index2tuceng.png"
                     class="shan" />
                <div style="padding:40px 50px">
                  <div class="bannerTitle">{{ item.title }}</div>
                  <div class="bannerline"></div>
                  <div class="bannerText">
                    <span v-html="ellipsis(item.detail, 120)"></span>
                  </div>
                  <div class="marginTop20">
                    <a href="javascript:void(0);"
                       @click="Towindowurl(item.url)"
                       class="bannerBtn">了解更多</a>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
    <div class="main display_between_nocenter EC_width"
         style="padding-bottom:20px;">
      <div class="mainLeft">
        <div class="gl_title_bar">
          <div class="gl_tb_left">
            <span class="normaltitle">{{ title1 }}</span>
          </div>
          <div class="gl_tb_right"
               @click="onMore(topLeftList[0].cid, title1)">
            <a href="javascript:;"
               class="gl_tb_right_more">
              <img src="/image/index/moreimg.png"
                   class="gltb_moreimg" />
              更多
            </a>
          </div>
        </div>
        <div class="tip_panel marginTop20 display_column">
          <img :src="topLeftList[0].slideShow"
               alt=""
               @click="clkNews(topLeftList[0], topLeftList[0].name)"
               v-if="topLeftList.length > 0" />
        </div>
      </div>
      <div class="mainCenter flex1">
        <div class="gl_title_bar">
          <div class="gl_tb_left">
            <span class="tagTitle"
                  :class="{ tagTitleActive: baseTagindex == index }"
                  @click="tagDatabase(index, item)"
                  v-for="(item, index) in intocommuni"
                  :key="index">
              {{ item.name }}
            </span>
          </div>
          <div class="gl_tb_right"
               @click="onMore(topMidList[0].cid, intocommuni[baseTagindex].name)">
            <a href="javascript:;"
               class="gl_tb_right_more">
              <img src="/image/index/moreimg.png"
                   class="gltb_moreimg" />
              更多
            </a>
          </div>
        </div>
        <div v-for="(item, index) in topMidList.slice(0, 7)"
             :key="index + '1'">
          <div class="gl_listWrapBar_nopad controlShow"
               style="margin: 20px 0;">
            <div class="gl_imgList setShow"
                 @click="clkNews(item, intocommuni[baseTagindex].name)">
              <img :src="item.slideShow"
                   width="150"
                   height="88"
                   class="imgtran" />
            </div>
            <a href="javascript:;"
               class="gl_listItem display_column">
              <div class="gl_listItemTitle fontBold setShow"
                   @click="clkNews(item, intocommuni[baseTagindex].name)">
                {{ item.title }}
              </div>
              <div class="gl_listItemTitle disShow"
                   style="width:640px;line-height:16px;margin-bottom:4px;overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                   @click="clkNews(item, intocommuni[baseTagindex].name)">
                {{ item.title }}
              </div>
              <div class="display_between marginTop10 setShow">
                <div>
                  <span v-bind:class="calculate(index)"
                        v-for="(qitem, index) in (item.labelName || '').split(',')"
                        :key="index"
                        @click="onsearch(qitem)">
                    {{ qitem }}
                  </span>
                </div>
                <div class="gl_inforshow ">
                  <span class="marginRight20">
                    {{ formatTime(item.publishtime, 'YYYY/MM/DD') }}
                  </span>
                  <span>
                    <img src="/image/index/chakan.png" />
                    {{ item.clickVolume }}
                  </span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="mainRight">
        <div class="gl_title_bar">
          <div class="gl_tb_left">
            <span class="normaltitle tagTitleActive">{{ title2 }}</span>
          </div>
        </div>
        <div class="topright">
          <!-- <div v-for="(item,index) in topRightList"
               :key="index">
            <img :src="item.slideShow"
                 alt="">
          </div> -->
          <div class="trbox seamless-warp"
               @click="clickProps($event)">
            <vue-seamless-scroll :data="topRightList"
                                 v-if="topRightList.length > 0"
                                 :class-option="classOption">
              <ul class="item">
                <li v-for="(item, index) in topRightList"
                    @click="Towindowurl(item.address)"
                    :key="index">
                  <img :src="item.slideShow"
                       :address="item.address"
                       alt="" />
                </li>
              </ul>
            </vue-seamless-scroll>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="text_center"
         @click="Towindowurl(item.url)"> -->
    <!-- <img src="/image/quanke/jcwsmid.png"
           width="1204px"
           class="imgtran" /> -->
    <div class="text_center"
         v-for="(item, index) in centerRotation"
         :key="3 - index"
         @click="Towindowurl(item.url)">
      <img :src="item.resUrl"
           class="imgtran"
           width="1204" />
    </div>
    <div class="main display_between_nocenter EC_width">
      <div class="mainLeft coursebox">
        <div class="gl_title_bar">
          <div class="gl_tb_left ctop">
            <span class="normaltitle"
                  style="margin-right:10px">社区卫生服务管理</span>
            <div :class="courseType == 0 ? 'ctopbq1' : 'ctopbq'"
                 @click="tobiaoqian(0, '家医签约')">家医签约</div>
            <div :class="courseType == 1 ? 'ctopbq1' : 'ctopbq'"
                 @click="tobiaoqian(1, '特色科室')">特色科室</div>
            <div :class="courseType == 2 ? 'ctopbq1' : 'ctopbq'"
                 @click="tobiaoqian(2, '优质服务')">优质服务</div>
          </div>
          <div class="gl_tb_right"
               @click="toCourseList()">
            <a href="javascript:;"
               class="gl_tb_right_more">
              <img src="/image/index/moreimg.png"
                   class="gltb_moreimg" />
              更多
            </a>
          </div>
        </div>
        <div class="cmid">
          <div class="t3mbox"
               v-for="(item, index) in kechengList"
               :style="(index + 1) % 3 == 0 ? 'margin-right:0' : ''"
               @click="tokecheng(item.id)"
               :key="index">
            <img :src="item.acr_PictResUrl"
                 alt="" />
            <div class="t3mboxbot">
              <span class="t3title">{{ item.title }}</span>
              <div class="t3biaoqian">
                <div v-for="(items, index) in item.labelName.split(',')"
                     :key="index + 's'"
                     :style="index == 0 ? 'margin-left:0' : ''"
                     v-show="items != ''">
                  <span>{{ items }}</span>
                </div>
              </div>
              <div class="t3more">
                <div>
                  <span style="color:red"
                        v-show="item.discountStatus == 2">免费</span>
                  <span v-show="item.discountStatus == 1">VIP专享</span>
                  <span v-show="item.discountStatus == 3">{{ item.price }}</span>
                </div>
                <div>
                  <img src="../../assets/img/icon/ren.png"
                       style="width:10px;height:11px;margin-right:10px"
                       alt="" />
                  <span>{{ item.playSum }}人</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="cmid"
             v-if="kechengList.length == 0">
          <p style="width:100%;text-align: center;">暂无课程</p>
        </div>
      </div>
      <div class="mainRight">
        <div class="gl_title_bar">
          <div class="gl_tb_left">
            <span class="normaltitle">{{ title3 }}</span>
          </div>
          <div class="gl_tb_right"
               @click="onMore(observationList[0].cid, title3)">
            <a href="javascript:;"
               class="gl_tb_right_more">
              <img src="/image/index/moreimg.png"
                   class="gltb_moreimg" />
              更多
            </a>
          </div>
        </div>
        <div class="marginTop17"
             v-for="(item, index) in observationList"
             :key="index + '1'"
             @click="clkNews(item, title3)">
          <div>
            <img class="imgBanner"
                 :src="item.slideShow"
                 alt=""
                 width="300px"
                 height="169" />
          </div>
          <div class="video_title">
            {{ ellipsis(item.title, 16) }}
          </div>
        </div>
      </div>
    </div>
    <div class="EC_width bot display_between"
         v-if="botRotation.length > 1">
      <img :src="botRotation[0].resUrl"
           @click="Towindowurl(botRotation[0].url)"
           alt="" />
      <img :src="botRotation[1].resUrl"
           @click="Towindowurl(botRotation[1].url)"
           alt="" />
    </div>
  </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll';
import format from '@/assets/unit/unit.js';
export default {
  name: 'health',
  components: {
    'vue-seamless-scroll': vueSeamlessScroll
  },
  computed: {
    classOption () {
      return {
        step: 0.5 // 数值越大速度滚动越快
        // limitMoveNum: this.topRightList.length, // 开始无缝滚动的数据量 this.dataList.length
        // hoverStop: true, // 是否开启鼠标悬停stop
        // direction: 1, // 0向下 1向上 2向左 3向右
        // openWatch: true, // 开启数据实时监控刷新dom
        // singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        // singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        // waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      };
    }
  },
  data () {
    return {
      // 基层动态切换
      baseTagindex: 0,
      swiperOption: {
        loop: true,
        // 显示分页
        pagination: {
          el: '.swiper-pagination',
          bulletClass: 'bulletWrite',
          bulletActiveClass: 'bulletWriteActive',
          clickable: true
        },
        autoplay: {
          delay: 15000,
          disableOnInteraction: false
        },

        on: {
          slideChangeTransitionEnd: () => {
            this.$refs.mySwiper.swiper.slideTo(this.$refs.mySwiper_info.swiper.activeIndex, 200, false);
          }
        }
      },
      swiperOption2: {
        loop: true,
        // 显示分页
        pagination: {
          el: '.swiper-pagination',
          bulletClass: 'bulletWrite',
          bulletActiveClass: 'bulletWriteActive',
          clickable: true
        },
        autoplay: {
          delay: 15000,
          disableOnInteraction: false
        },

        on: {
          slideChangeTransitionEnd: () => {
            this.$refs.mySwiper_info.swiper.slideTo(this.$refs.mySwiper.swiper.activeIndex, 200, false);
          }
        }
      },
      intocommuni: [], //走进社区，主任风采，加以团队，家医风采
      topRotation: [],
      centerRotation: [],
      botRotation: [],
      columntopList: [],
      tmList1: [], //基层动态
      observationList: [], //基层锐观察
      topLeftList: [], //基层刊物
      tmList2: [], //走进社区
      tmList3: [], //家医团队
      tmList4: [], //家医风采
      colorList: ['gl_gree_block', 'gl_red_block', 'gl_blue_block'],
      courseType: 0,
      kechengList: [],
      title1: '',
      title2: '',
      title3: '',
      topMidList: [],
      topRightList: []
    };
  },
  created () {
    this.GetRotationInfo();
    this.GetColumsInfoAllList();
    this.getlist('家医签约');
  },
  methods: {
    onsearch (keywords) {
      const { href } = this.$router.resolve({
        path: '/home/searchPage?',
        query: {
          labelname: keywords
        }
      });
      window.open(href, '_blank');
    },
    calculate (index) {
      var nm = this.colorList[Math.floor(index % 3)];
      return nm;
    },
    tagDatabase (index, item) {
      // 基层动态0 主任风采1 家医团队2 家医风采3数据
      if (index == this.baseTagindex) {
        return;
      } else {
        if (index == 0) this.topMidList = this.tmList1;
        else if (index == 1) this.topMidList = this.tmList2;
        else if (index == 2) this.topMidList = this.tmList3;
        else if (index == 3) this.topMidList = this.tmList4;
        this.baseTagindex = index;
      }
    },

    /**tianlianpei */
    /**获取轮播数据 */
    GetRotationInfo () {
      let _this = this;
      let arr = [6, 7, 8];
      for (let i = 0; i < arr.length; i++) {
        _this.httphelper
          .post('/api/WebSetMessApi/GetRotationInfo', {
            type: arr[i],
            ruselocation: 1,
            source: 2
          })
          .then(res => {
            if (res.data.code == 200) {
              if (arr[i] == 6) _this.topRotation = res.data.data || null;
              else if (arr[i] == 7) _this.centerRotation = res.data.data || null;
              else if (arr[i] == 8) _this.botRotation = res.data.data || null;
            }
          });
      }
    },

    /**获取栏目数据 */
    GetColumsInfoAllList () {
      let _this = this;
      _this.httphelper
        .post('/api/NewApi/GetColumsInfoAllList', {
          cType: 1,
          isCHorEN: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            let data = res.data.data.sort(function (a, b) {
              return a.sort - b.sort;
            });
            data.forEach(item => {
              switch (item.id) {
                case 49:
                  _this.intocommuni.push(item);
                  _this.columntopList.push(item);
                  break;
                case 50:
                  _this.title3 = item.name;
                  _this.columntopList.push(item);
                  break;
                case 51:
                  _this.intocommuni.push(item);
                  _this.columntopList.push(item);
                  break;
                case 53:
                  _this.intocommuni.push(item);
                  _this.columntopList.push(item);
                  break;
                case 54:
                  _this.intocommuni.push(item);
                  _this.columntopList.push(item);
                  break;
                case 208:
                  _this.title1 = item.name;
                  _this.columntopList.push(item);
                  break;
                case 209:
                  _this.title2 = item.name;
                  _this.columntopList.push(item);
                  break;
              }
            });
            //获取首页热门内容数据
            _this.GetGpSiteNewInfoPageList();
          }
        });
    },
    /**获取首页中部新闻信息 */
    GetGpSiteNewInfoPageList () {
      let _this = this;
      let arrcolumntop = _this.columntopList;
      let pagesize = 4;
      for (let i = 0; i < arrcolumntop.length; i++) {
        if (arrcolumntop[i].id == 208) pagesize = 1;
        else if (arrcolumntop[i].id == 209) pagesize = 50;
        else if (arrcolumntop[i].id == 49 || arrcolumntop[i].id == 51) pagesize = 7;
        else if (arrcolumntop[i].id == 53 || arrcolumntop[i].id == 54) pagesize = 7;
        else if (arrcolumntop[i].id == 50) pagesize = 3;
        _this.httphelper
          .post('/api/NewApi/GetGpSiteNewInfoPageList', {
            keyword: '',
            id: 0,
            parentID: 0,
            column_Type: arrcolumntop[i].id,
            pageIndex: 1,
            pageSize: pagesize
          })
          .then(res => {
            if (res.data.code == 200) {
              let gpSiteNewInfoViewsViews = res.data.data.gpSiteNewInfoViewsViews;
              if (gpSiteNewInfoViewsViews != null && gpSiteNewInfoViewsViews.length > 0) {
                // gpSiteNewInfoViewsViews = gpSiteNewInfoViewsViews.slice(0, 8)
                gpSiteNewInfoViewsViews.forEach(item => {
                  if (item.cid == 208) {
                    _this.topLeftList.push(item);
                  } else if (item.cid == 49) {
                    _this.tmList1.push(item);
                    _this.topMidList.push(item);
                  } else if (item.cid == 51) {
                    _this.tmList2.push(item);
                  } else if (item.cid == 53) {
                    _this.tmList3.push(item);
                  } else if (item.cid == 54) {
                    _this.tmList4.push(item);
                  } else if (item.cid == 50) {
                    _this.observationList.push(item);
                  } else if (item.cid == 209) {
                    _this.topRightList.push(item);
                    // _this.topRightList.push(item);
                    // _this.topRightList.push(item);
                  }
                });
              }
            }
          });
      }
    },
    /**新闻的点击事件 */
    clkNews (info, meuntitle) {
      //如果外连接存在，跳转外链，否则跳转详情
      if (Object.keys(info.address).length == 0) {
        var param = {
          pid: 35,
          title: meuntitle,
          cid: info.cid,
          goroutename: 'grassheal/Inforlist'
        };
        localStorage.setItem('Inforlist_param_' + info.cid, JSON.stringify(param));
        const { href } = this.$router.resolve({
          path: '/grassheal/Inforlist/inforDetails?',
          query: {
            id: info.id,
            column_Type: info.cid
          }
        });
        window.open(href, '_blank');
      } else {
        window.open(info.address);
      }
    },
    /**轮播、广告图跳转外链 */
    Towindowurl (url) {
      if (url != null && url != '') window.open(url);
    },
    formatTime (datatime, timeformat) {
      return format(datatime, timeformat);
    },
    /**更多 */
    onMore (cid, conetntitle) {
      this.$router.push({
        path: '/grassheal/Inforlist',
        query: {
          pid: 35,
          title: conetntitle,
          cid: cid
        }
      });
    },
    getlist (name) {
      this.httphelper
        .post('/api/NewApi/GetDbRecommendHomeCoursePageList', {
          labelName: name,
          number: 6
        })
        .then(res => {
          if (res.data.code == 200) {
            this.kechengList = res.data.data;
          }
        });
    },
    tobiaoqian (index, name) {
      if (this.courseType == index) return;
      this.courseType = index;
      this.getlist(name);
    },
    tokecheng (id) {
      window.open(this.httphelper.IsDebugCgphome() +'/detail?courseId=' + id, '_blank');
    },
    toCourseList () {
      let str = '';
      if (this.courseType == 0) str = '专题合作';
      else if (this.courseType == 1) str = '特色专科';
      else if (this.courseType == 2) str = '优质服务';
      window.open(this.httphelper.IsDebugCgphome() +'/allCourse?keyword=' + str, '_blank');
    },
    clickProps (e) {
      if (e.target.address != undefined) this.Towindowurl(e.target.address);
    }
  },
  mounted () { }
};
</script>

<style scoped>
.content {
    flex: 1;
}

.bannerWrap {
    height: 450px;
    padding-top: 40px;
    box-sizing: border-box;
    background: linear-gradient(180deg, #dbeded, #ffffff);
    min-width: 1240px;
}

/* 上部banner */

.topbanner {
    height: 380px;
}

.bannerleft {
    width: 930px;
    height: 380px;
    /* background: #005660; */
    box-shadow: 0px 16px 14px 0px rgba(0, 0, 0, 0.15);
    border-radius: 20px 0px 0px 0px;
}

.bannerright {
    width: 299px;
    height: 380px;
    background: #dfa633;
    box-shadow: 0px 16px 14px 0px rgba(0, 0, 0, 0.15);
    border-radius: 0px 0px 20px 0px;
    overflow: hidden;
    /* padding: 50px 40px; */
    box-sizing: border-box;
    position: relative;
}
.swiper-container,
.swiper-slide {
    width: 100%;
    height: 100%;
}
.shan {
    position: absolute;
    right: 0;
    bottom: 0;
}
.bannerTitle {
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
    line-height: 38px;
}
.bannerText {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
    line-height: 25px;
}
.bannerline {
    width: 40px;
    height: 1px;
    background: #ffffff;
    margin-top: 20px;
    margin-bottom: 18px;
}
.bannerBtn {
    display: inline-block;
    width: 121px;
    height: 32px;
    background: #ffffff;
    border-radius: 16px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #000000;
    line-height: 32px;
    text-align: center;
}
.main {
    padding: 50px 0;
}

.mainCenter {
    margin: 0 50px;
}

.mainLeft {
    width: 200px;
}

.mainRight {
    width: 300px;
}

.tip_panel {
    width: 200px;
    height: 290px;
    /* background: #ed4806;
    padding: 10px; */
    box-sizing: border-box;
    margin-bottom: 20px;
    /* padding-left: 20px;
    padding-right: 28px;
    padding-bottom: 23px;
    height: 302px;
    background: url(/image/index/leftbgjiceng.png) no-repeat;
    background-size: 100% 100%; */
}
.tip_panel img {
    width: 200px;
    max-height: 272px;
}
.swiper-pagination {
    text-align: left;
    box-sizing: border-box;
    padding-left: 20px;
}
.setShow {
    display: none;
}
.controlShow:hover .setShow {
    display: flex;
}
.controlShow:hover .disShow {
    display: none;
}
.bot {
    margin: 0px auto 60px;
}
.bot img {
    width: 608px;
    cursor: pointer;
}
.coursebox {
    flex: 1;
    margin-right: 50px;
}
.ctop {
    display: flex;
    align-items: center;
}
.ctopbq {
    padding: 7px 20px;
    line-height: 16px;
    border: 1px solid #eee;
    border-radius: 30px;
    margin-left: 5px;
    margin-top: -10px;
    cursor: pointer;
}
.ctopbq1 {
    padding: 7px 20px;
    line-height: 16px;
    border: 1px solid #eee;
    border-radius: 30px;
    margin-left: 5px;
    margin-top: -10px;
    background-color: #0b8686;
    color: #fff;
    cursor: pointer;
}
.cmid {
    display: flex;
    flex-wrap: wrap;
    margin-top: 17px;
}

.t3mbox {
    height: 300px;
    width: 280px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    margin-right: 25px;
    margin-bottom: 25px;
    background: #ffffff;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.04);
    border-radius: 0px 0px 5px 5px;
    cursor: pointer;
}
.t3mbox img {
    height: 158px;
    width: 280px;
}
.t3mboxbot {
    padding: 15px 15px 20px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    height: 100%;
}
.t3title {
    width: 100%;
    height: 38px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 20px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
.t3more {
    height: 14px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #919ca3;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.t3biaoqian {
    display: flex;
    flex-wrap: wrap;
}
.t3biaoqian div {
    background: #ffffff;
    border: 1px solid #979fa6;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #979fa6;
    padding: 0px 3px;
    /* margin-left: 3px; */
    margin-right: 3px;
    margin-top: 1px;
    margin-bottom: 1px;
}
.t3biaoqian span {
    white-space: nowrap;
}
.marginTop17 .video_title {
    margin-top: 4px;
    margin-bottom: 20px;
    font-size: 14px;
}
.topright img {
    height: 40px;
    margin-bottom: 20px;
    cursor: pointer;
}
.topright {
    height: 271px;
    margin-top: 20px;
    /* overflow-y: auto; */
}
.seamless-warp {
    height: 271px;
    overflow: hidden;
}
</style>
